module.exports = __webpack_public_path__ + "7679050b2113e7fad660840c77b16f23.svg";